export interface TranslateConfig {
    enabled: boolean;
    defaultLang: string;
    supportedLangs: string[];
}

export const DEFAULT_TRANSLATE_CONFIG: TranslateConfig = {
    enabled: true,
    defaultLang: 'km',
    supportedLangs: ['en','km']
};
